module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_x-1-chapter-number-14"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0004"
    }
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-2-chapter-title"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_x-2-chapter-title"
  }, [_c('span', [_vm._v("Legends of the First People")])]), _vm._v(" "), _c('p', {
    staticClass: "P_div_frame-2"
  }, [_c('span')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "P_div_frame-2",
    staticStyle: {
      "width": "80%",
      "max-width": "100%",
      "max-height": "100%",
      "display": "inline-block"
    }
  }, [_c('span', [_c('img', {
    staticClass: "frame-13",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "bm08.jpg",
      "id": "bm08_fmt",
      "src": "bm08_fmt.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "P_caption-16__And__Centre_Alignment"
  }, [_c('span', [_vm._v("The shoreline of the Biloxi peninsula with Deer Island in the background "), _c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("(Author’s collection)")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Propelled by the gentle surf, a froth of white bubbles swirled around their ankles as the two men stepped from the dugout canoe on to the sandy shoreline. Their lean bodies were clad only in breechcloths held up by beaded cords, while their faces were adorned with tattoos inked in deep hues of red and black. They were Tanêksa, returning to the narrow offshore island to fish and gather oysters. Alarmed by their presence, a small brown deer skittered away, seeking the safety of a scraggly line of scrub pine trees. The men’s dark eyes tracked the deer as they reached for the spears lying in the bottom of the canoe. Just as the predators were prepared for the hunt, they were distracted by a strange vessel approaching the mainland from the west. The Tanêksa crouched low behind a large mound of oyster shells and watched in trepidation as the new people came to their lands.")]), _vm._v(" "), _c('p', {
    staticClass: "P_div_frame-2"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_div_frame-2"
  }, [_c('span', [_c('img', {
    staticClass: "frame-14",
    staticStyle: {
      "height": "80%",
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "bm09.jpg",
      "id": "bm09_fmt",
      "src": "bm09_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_caption-16__And__Centre_Alignment"
  }, [_c('span', [_vm._v("The City of Biloxi pays tribute to its founder Pierre LeMoyne, Sieur d’Iberville "), _c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("(Author’s collection)")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Historian Bill Raymond identifies the newcomers. “The first Europeans to arrive in Biloxi were led by Pierre LeMoyne, Sieur d’Iberville, a French-Canadian explorer who was charged with finding the mouth of the Mississippi. On February 10, 1699, d’Iberville arrives at Ship Island, which is where the deep water is. And from there . . . he actually lands on the shore of the Biloxi peninsula. And from reading the journals and looking at it, we suspect it’s about in the area where the Edgewater Mall is today [west Biloxi].”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Iberville’s group, says Raymond, founded “the first permanent French settlement over in present day Ocean Springs, Mississippi,” which they recorded on early maps as "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Bilocci")]), _vm._v(". Legend says the French chose the name to honor the natives who were instrumental in their survival. In "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Tanêksqyaa ade")]), _vm._v(", the language of the natives, their name means “First People.” Filtered through the French of the explorers, the “First People” were called Biloxi. Other European chroniclers recorded the tribe’s name with variations such as "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Baluxa, Beluxi,")]), _vm._v(" "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Bilocchi")]), _vm._v(", and "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Biloxe")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Dr. Val Husley, director emeritus of the Biloxi Maritime and Seafood Heritage Museum, confirms that “when Iberville and his brother Bienville arrived here and made their way down the beach, they sighted the Biloxi natives paddling dugouts from the mainland over to Deer Island.” Husley believes the two groups—European and Native American—met and established a peaceful co-existence; sharing in the bounty of the region.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("In one of history’s often illogical twists, the peninsula where Iberville landed and named for the original inhabitants would cease to be their home. The city of Biloxi, Mississippi, has a population of over forty-four thousand, but the descendants of the Biloxi people live in Louisiana. Their three principal clans—the "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Iitaanyadi")]), _vm._v(" (Deer people), "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Ontianyadi")]), _vm._v(" (Bear people), and "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Nakhotodhanyadi")]), _vm._v(" (Alligator people)—began to migrate and merge with other tribes. Prior to their great exodus, they played a pivotal role in one enduring love story.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("A warrior from the Pascagoula tribe fell in love with the daughter of the Biloxi chief and sought permission to marry her. The chief withheld his approval. In her poem “The Live Oak Ring,” Laura F. Hinsdale provides a dramatic rendition of the condition imposed by the chief before such a union could occur:")]), _vm._v(" "), _c('p', {
    staticClass: "P_extract-3"
  }, [_vm._v("When a ring grows on yonder tree, and circles yonder bough")]), _vm._v(" "), _c('p', {
    staticClass: "P_extract-3"
  }, [_vm._v("Then you may bear my child from me, and wed with ring and vow.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("The tormented couple could not imagine how a tree could conjure up a ring. Yet, the next morning, after a fierce storm had passed, the sun’s rays danced across the rippling waters. The branch of a large oak seemed to be reaching out and calling to them. The eyes of the young lovers traveled along its length. To their astonishment, there within a craggy crook a circle had opened up, forming a perfect ring.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Hinsdale’s poem about the ring in the oak preserved the legend for future generations. Variations of the legend have appeared in newspapers along the Gulf Coast. A 1925 "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("New Orleans Times-")]), _c('br'), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Picayune")]), _vm._v(" article describes the two lovers as a prince and princess from opposing tribes, while a 1936 newspaper report concluded that after the appearance of the ring in the oak, the marriage of the daughter of the chief of the Biloxi and her Pascagoula suitor united the tribes and brought peace to the region.")]), _vm._v(" "), _c('p', {
    staticClass: "P_div_frame-2"
  }, [_c('span')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "P_div_frame-2",
    staticStyle: {
      "width": "80%",
      "max-width": "100%",
      "max-height": "100%",
      "display": "inline-block"
    }
  }, [_c('span', [_c('img', {
    staticClass: "frame-15",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "bm10jpg.jpg",
      "id": "bm10jpg_fmt",
      "src": "bm10jpg_fmt.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "P_caption-16__And__Centre_Alignment"
  }, [_c('span', [_vm._v("The “ring” in the oak saved two young lovers of the Biloxi and Pascagoula tribes "), _c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("(Courtesy John Stachura Collection)")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("The magical tree sprouting a lovers’ ring drew curious visitors to pose beneath its branches. The best part of this ingenious tale is that the tree still exists. Even the combined wrath of hurricanes Camille and Katrina was unable to topple the majestic oak. Prior to 1969, the tree stood directly in front of the rectory of the Church of the Redeemer along Beach Boulevard in east Biloxi. Now, without the rectory as a landmark, it is difficult to spot. The best view of the “ring in the oak” is from the beach side of the highway as new young sprouts and leaves threaten to close the opening from the opposite side.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Harrison County librarian Jane Shambra describes the ring in the tree as more of “a hole big enough that you could put your hand through it,” formed by two branches twisted and grown together, but she accepts the legend with a broad smile. “It’s just a really neat love story, and you can go to the tree and see for yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_caption-16__And__Centre_Alignment"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_caption-16__And__Centre_Alignment"
  }, [_c('span', [_vm._v("The legendary oak with its “ring” can still be found on Beach Boulevard "), _c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("(Author’s collection)")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "P_div_frame-2",
    staticStyle: {
      "width": "80%",
      "max-width": "100%",
      "max-height": "100%",
      "display": "inline-block"
    }
  }, [_c('span', [_c('img', {
    staticClass: "frame-16",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "bm11.jpg",
      "id": "bm11_fmt",
      "src": "bm11_fmt.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Other than the incomparable oak, there are few tangible tribal artifacts left in Biloxi. “What we know about the Native Americans here is very limited.” Dr. Husley takes a key and opens a glass case in the maritime museum and indicates some pottery shards on display. “We know they gathered and ate oysters, because we found oyster shells and oyster mounds both in Biloxi and just offshore on Deer Island. They would also cook the shells and take the fine particles and make a mortar out of it to form their clay pottery, and that’s what distinguishes Biloxi pottery—the particles of oyster shells. So if you pick up a piece of Native American pottery here you are going to see these little white specs in there. The first time I realized what it was I said, ‘Ah, ha!’ You know, one of those moments. You see them throughout the whole vessel.” Dr. Husley’s brow furrows as he says with regret, “You rarely find a whole vessel. The broken vessels they threw away, that’s the ones we find. The good vessels, naturally, they took with them.” And though they no longer live in Biloxi, Mississippi, descendants of the Biloxi people survived. They forged an alliance with the Tunica tribe and in 1981 the combined Tunica-Biloxi tribe was granted recognition by the federal government. The motto on their tribal flag proclaims: “Cherishing Our Past, Building Our Future.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_div_frame-2"
  }, [_c('span')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "P_div_frame-2",
    staticStyle: {
      "width": "80%",
      "max-width": "100%",
      "max-height": "100%",
      "display": "inline-block"
    }
  }, [_c('span', [_c('img', {
    staticClass: "frame-9",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "bm12.jpg",
      "id": "bm12_fmt",
      "src": "bm12_fmt.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "P_caption-16__And__Centre_Alignment"
  }, [_c('span', [_vm._v("The lovers’ “ring” in the ancient oak’s branch "), _c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("(Author’s collection)")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-15"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-15"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-12"
  }, [_vm._v("Lagniappe:")]), _vm._v(" When the Biloxi and Tunica merged they had to overcome a language barrier before they could share traditions and beliefs. The Tunica spoke a language isolate, one with no known historical or linguistic relationship to any other language. The Biloxi spoke a Siouan-based dialect. Since both tribes had a long history with French explorers, settlers, and traders, they shifted to French supplemented by Mobilian jargon, a mixture of native and French words. In 1934, eighty-year-old Emma Jackson was identified as the last speaker of "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Tanêksqyaa ade")]), _vm._v(", the Biloxi language. In the present day, tribal members, descendants of both the Tunica and the Biloxi, speak English with a small spattering of French among the elders. Many live on the Tunica-Biloxi Indian Reservation in central Avoyelles Parish, just south of the city of Marksville, Louisiana.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "P_div_frame-2",
    staticStyle: {
      "width": "80%",
      "max-width": "100%",
      "max-height": "100%",
      "display": "inline-block"
    }
  }, [_c('span', [_c('img', {
    staticClass: "frame-17",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "bm13.jpg",
      "id": "bm13_fmt",
      "src": "bm13_fmt.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "P_caption-16__And__Centre_Alignment"
  }, [_c('span', [_vm._v("Native American pottery shards embedded with fragments of oyster shells "), _c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("(Author’s collection)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35038beb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0008.vue
// module id = 78
// module chunks = 0